import { useState } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";


const OpenModelModal = ({ account_id, show, handleClose, fetchRecords, selectedModel }) => {
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });


    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">
                    {selectedModel.name}
                    {selectedModel.version && ` v${selectedModel.version}`}
                </p>
            </div>

            <div className="modal_main_cont">

                {selectedModel?.creator_name && (
                    <div className="item_content_model">
                        <label className="model_label">Creator</label>
                        <p>{selectedModel.creator_name}</p>
                    </div>
                )}

                {selectedModel?.inference_provider && (
                    <div className="item_content_model">
                        <label className="model_label">Inference Provider</label>
                        <p>{selectedModel.inference_provider}</p>
                    </div>
                )}

                {selectedModel?.name && (
                    <div className="item_content_model">
                        <label className="model_label">Name</label>
                        <p>{selectedModel.name}</p>
                    </div>
                )}

                {selectedModel?.version && (
                    <div className="item_content_model">
                        <label className="model_label">Version</label>
                        <p>{selectedModel.version}</p>
                    </div>
                )}

                {selectedModel?.description && (
                    <div className="item_content_model">
                        <label className="model_label">Description</label>
                        <p>{selectedModel.description}</p>
                    </div>
                )}

                {selectedModel?.model_family && (
                    <div className="item_content_model">
                        <label className="model_label">Model Family</label>
                        <p>{selectedModel.model_family}</p>
                    </div>
                )}

                {selectedModel?.architecture && (
                    <div className="item_content_model">
                        <label className="model_label">Architecture</label>
                        <p>{selectedModel.architecture}</p>
                    </div>
                )}

                {selectedModel?.parameter_count && (
                    <div className="item_content_model">
                        <label className="model_label">Parameter Count</label>
                        <p>{selectedModel.parameter_count}</p>
                    </div>
                )}

                {/* Boolean fields must check !== undefined */}
                {selectedModel?.supports_text !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Text</label>
                        <p>{String(selectedModel.supports_text)}</p>
                    </div>
                )}

                {selectedModel?.supports_vision !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Vision</label>
                        <p>{String(selectedModel.supports_vision)}</p>
                    </div>
                )}

                {selectedModel?.supports_audio !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Audio</label>
                        <p>{String(selectedModel.supports_audio)}</p>
                    </div>
                )}

                {selectedModel?.supports_video !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Video</label>
                        <p>{String(selectedModel.supports_video)}</p>
                    </div>
                )}

                {selectedModel?.supports_function_calling !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Function Calling</label>
                        <p>{String(selectedModel.supports_function_calling)}</p>
                    </div>
                )}

                {selectedModel?.supports_tools !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Tools</label>
                        <p>{String(selectedModel.supports_tools)}</p>
                    </div>
                )}

                {selectedModel?.supports_json_mode !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports JSON Mode</label>
                        <p>{String(selectedModel.supports_json_mode)}</p>
                    </div>
                )}

                {selectedModel?.supports_streaming !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Streaming</label>
                        <p>{String(selectedModel.supports_streaming)}</p>
                    </div>
                )}

                {selectedModel?.supports_embeddings !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Embeddings</label>
                        <p>{String(selectedModel.supports_embeddings)}</p>
                    </div>
                )}

                {selectedModel?.supports_fine_tuning !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Supports Fine Tuning</label>
                        <p>{String(selectedModel.supports_fine_tuning)}</p>
                    </div>
                )}

                {selectedModel?.max_context_tokens && (
                    <div className="item_content_model">
                        <label className="model_label">Max Context Tokens</label>
                        <p>{selectedModel.max_context_tokens}</p>
                    </div>
                )}

                {selectedModel?.max_output_tokens && (
                    <div className="item_content_model">
                        <label className="model_label">Max Output Tokens</label>
                        <p>{selectedModel.max_output_tokens}</p>
                    </div>
                )}

                {selectedModel?.input_price_per_1M_tokens && (
                    <div className="item_content_model">
                        <label className="model_label">Input Price per 1M Tokens</label>
                        <p>{selectedModel.input_price_per_1M_tokens}</p>
                    </div>
                )}

                {selectedModel?.output_price_per_1M_tokens && (
                    <div className="item_content_model">
                        <label className="model_label">Output Price per 1M Tokens</label>
                        <p>{selectedModel.output_price_per_1M_tokens}</p>
                    </div>
                )}

                {selectedModel?.embedding_price_per_1M_tokens && (
                    <div className="item_content_model">
                        <label className="model_label">Embedding Price per 1M Tokens</label>
                        <p>{selectedModel.embedding_price_per_1M_tokens}</p>
                    </div>
                )}

                {selectedModel?.latency_tier && (
                    <div className="item_content_model">
                        <label className="model_label">Latency Tier</label>
                        <p>{selectedModel.latency_tier}</p>
                    </div>
                )}

                {selectedModel?.reasoning_level && (
                    <div className="item_content_model">
                        <label className="model_label">Reasoning Level</label>
                        <p>{selectedModel.reasoning_level}</p>
                    </div>
                )}

                {selectedModel?.training_cutoff && (
                    <div className="item_content_model">
                        <label className="model_label">Training Cutoff</label>
                        <p>{selectedModel.training_cutoff}</p>
                    </div>
                )}

                {selectedModel?.is_public !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Public</label>
                        <p>{String(selectedModel.is_public)}</p>
                    </div>
                )}

                {selectedModel?.is_deprecated !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Deprecated</label>
                        <p>{String(selectedModel.is_deprecated)}</p>
                    </div>
                )}

                {selectedModel?.is_preview !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Preview</label>
                        <p>{String(selectedModel.is_preview)}</p>
                    </div>
                )}

                {selectedModel?.requires_approval !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Requires Approval</label>
                        <p>{String(selectedModel.requires_approval)}</p>
                    </div>
                )}

                {selectedModel?.api_endpoint && (
                    <div className="item_content_model">
                        <label className="model_label">API Endpoint</label>
                        <p>{selectedModel.api_endpoint}</p>
                    </div>
                )}

                {selectedModel?.license_type && (
                    <div className="item_content_model">
                        <label className="model_label">License Type</label>
                        <p>{selectedModel.license_type}</p>
                    </div>
                )}

                {selectedModel?.is_open_weights !== undefined && (
                    <div className="item_content_model">
                        <label className="model_label">Open Weights</label>
                        <p>{String(selectedModel.is_open_weights)}</p>
                    </div>
                )}

            </div>
            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : "Deploy model"}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        Close
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default OpenModelModal;